import { Link } from "react-router-dom";
import { useMeta } from "../lib/seo";
import { Button } from "./ui/button";

// Shared 404 body: point people at the three things they most likely came for instead of a dead end.
export function NotFoundContent() {
  return (
    <div className="max-w-3xl mx-auto px-4 py-24 text-center" data-testid="not-found-page">
      <h1 className="text-3xl font-extrabold">Page not found</h1>
      <p className="text-slate-600 mt-3">That page may have moved. Here's where most people are headed:</p>
      <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
        <Button asChild className="bg-emerald-700 hover:bg-emerald-800 rounded-full px-6 min-h-[44px]" data-testid="not-found-check-button">
          <Link to="/check">Check my denial free</Link>
        </Button>
        <Button asChild variant="outline" className="rounded-full px-6 min-h-[44px] border-emerald-700 text-emerald-700 hover:bg-emerald-50" data-testid="not-found-guides-button">
          <Link to="/guide">Read the free guides</Link>
        </Button>
        <Button asChild variant="ghost" className="rounded-full px-6 min-h-[44px]" data-testid="not-found-home-button">
          <Link to="/">Go home</Link>
        </Button>
      </div>
      <p className="text-slate-500 mt-8 text-sm">If you followed a link on our site that should work, let us know at <a href="mailto:support@decodemydenial.com" className="text-emerald-700 underline" data-testid="not-found-contact">support@decodemydenial.com</a>.</p>
    </div>
  );
}

// Catch-all route for paths no other route matches (e.g. /guide/a/b), which previously rendered an empty page.
export default function NotFound() {
  useMeta("Page not found | Denial Decoder", undefined, { noindex: true });
  return <NotFoundContent />;
}
